export function getPathAndName(pageName: string) {
  const isModule = pageName.includes('::');
  if (isModule) {
    const [module, name] = pageName.split('::');
    return [`../../app/${module}/resources/js/pages/`, name];
  }

  return [`./pages/`, pageName];
}
